import { COMMON } from './common.constant';

export const IMS_SYNC_STATUS = Object.freeze({
  NOT_SENT: 0,
  PENDING: 1,
  SUCCESS: 2,
  FAILED: 3,
});

export const IMS_MARKET = Object.freeze({
  US_AU: 'us-au',
  PH: 'ph',
  OTHER: 'other',
});

export const IMS_PACKAGE_OPTIONS = Object.freeze({
  [IMS_MARKET.US_AU]: [
    { value: 'CUK.TRL', labelKey: 'ImsPackageTrial' },
    { value: 'CUK.STT', labelKey: 'ImsPackageStarter' },
    { value: 'CUK.STD', labelKey: 'ImsPackageStandard' },
    { value: 'CUK.ENT', labelKey: 'ImsPackageAdvanced' },
  ],
  [IMS_MARKET.PH]: [
    { value: 'CUK.STT', labelKey: 'ImsPackageStarter' },
    { value: 'CUK.STD', labelKey: 'ImsPackageStandard' },
    { value: 'CUK.PRO', labelKey: 'ImsPackageProfessional' },
    { value: 'CUK.ENT', labelKey: 'ImsPackageEnterprise' },
  ],
  [IMS_MARKET.OTHER]: [
    { value: 'CUK.STD', labelKey: 'ImsPackageStandard' },
    { value: 'CUK.PRO', labelKey: 'ImsPackageProfessional' },
    { value: 'CUK.ENT', labelKey: 'ImsPackageEnterprise' },
  ],
});

export const IMS_MARKET_FIELDS = Object.freeze({
  [IMS_MARKET.US_AU]: ['Kiot'],
  [IMS_MARKET.PH]: ['OnlineReservation', 'OrderOnline', 'OrderTable', 'Lomas'],
  [IMS_MARKET.OTHER]: ['OrderOnline', 'OrderTable', 'Lomas'],
});

export const IMS_REQUEST_TYPE_OPTIONS = Object.freeze([
  { value: 'new', labelKey: 'ImsRequestTypeNew' },
  { value: 'renewal', labelKey: 'ImsRequestTypeRenewal' },
  { value: 'free', labelKey: 'ImsRequestTypeFree' },
]);

export const IMS_DEVICE_OPTIONS = Object.freeze({
  [IMS_MARKET.US_AU]: ['POS', 'Tablet', 'Kiot'],
  [IMS_MARKET.PH]: ['POS', 'MO/KDS'],
});

/**
 * Nhãn hiển thị combobox thiết bị theo thị trường (BUG-016).
 * Value nội bộ giữ nguyên (POS/Tablet/MO/KDS/Kiot) — chỉ label hiển thị đổi theo market.
 * PH: POS → Cashier Window, MO/KDS → Mobile Ordering / Kitchen Display System (spec #42).
 * US_AU: giữ nguyên POS / Tablet/Handheld / Self-Ordering KIOSK.
 */
export const IMS_DEVICE_LABELS = Object.freeze({
  [IMS_MARKET.US_AU]: {
    POS: 'POS',
    Tablet: 'Tablet/Handheld',
    Kiot: 'Self-Ordering KIOSK',
  },
  [IMS_MARKET.PH]: {
    POS: 'Cashier Window',
    'MO/KDS': 'Mobile Ordering / Kitchen Display System',
  },
  [IMS_MARKET.OTHER]: {},
});

/**
 * Quy đổi raw DeviceCode trả về từ getLicenseSuman (BranchResource[].Resource.Devices)
 * sang bucket thiết bị của combobox popup. 'POS' → vị trí 0, 'MO/KDS'/'Tablet' → vị trí 1.
 * Code lạ rơi về bucket 'tablet'.
 */
export const IMS_DEVICE_CODE_ALIAS = Object.freeze({
  POS: 'pos',
  'MO/KDS': 'tablet',
  Tablet: 'tablet',
  Kiot: 'kiot',
});

export const IMS_BUSINESS_OPTIONS = Object.freeze([
  'Online Reservation',
  'Website Ordering',
  'QR Dine-in',
  'Advanced Inventory',
  'Centralize Loyalty Program',
  'Promotion',
]);

export const IMS_BUSINESS_FEATURE_MAP = Object.freeze({
  'Online Reservation': 'Online Reservation',
  'Website Ordering': 'Website Ordering',
  'QR Dine-in': 'QR Dine-in',
  'Advanced Inventory': 'Advanced Inventory',
  'Promotion advance': 'Promotion',
  'LOMAS Customer Loyalty Program': 'Centralize Loyalty Program',
});

/**
 * Map upgrade_type LH → RequestType IMS (0=Bán mới, 1=Gia hạn, 2=Miễn phí).
 * EXTEND/AUTO_EXTEND → 1, còn lại → 0. Miễn phí không dùng.
 */
export const IMS_REQUEST_TYPE_FROM_UPGRADE = Object.freeze({
  [COMMON.UPGRADE]: 0,
  [COMMON.EXTEND]: 1,
  [COMMON.PURCHASE]: 0,
  [COMMON.PURCHASE_LICENSE]: 0,
  [COMMON.AUTO_EXTEND]: 1,
});

/**
 * BUG-016 — Map SaleOrderTypeID CRM → danh sách option RequestType IMS cho phép chọn
 * + default khi CRM đổi. 0=Bán mới, 1=Gia hạn, 3=Miễn phí.
 * - CRM 1 (Bán mới) → [0, 3], default 0
 * - CRM 3 (Gia hạn) → [1, 3], default 1
 * - CRM 2 (Nâng cấp) → [0, 3], default 0
 * - CRM 7 (Bán thêm) → [0, 3], default 0
 * - CRM 4 (Đào tạo) → [3], default 3
 * - CRM rỗng/khác → [0, 1, 3], default 0
 */
export const IMS_REQUEST_TYPE_BY_CRM = Object.freeze({
  1: { options: [0, 3], default: 0 },
  3: { options: [1, 3], default: 1 },
  2: { options: [0, 3], default: 0 },
  7: { options: [0, 3], default: 0 },
  4: { options: [3], default: 3 },
});

export const IMS_REQUEST_TYPE_DEFAULT = Object.freeze({ options: [0, 1, 3], default: 0 });

export default {
  IMS_SYNC_STATUS,
  IMS_MARKET,
  IMS_PACKAGE_OPTIONS,
  IMS_MARKET_FIELDS,
  IMS_REQUEST_TYPE_OPTIONS,
  IMS_DEVICE_OPTIONS,
  IMS_DEVICE_LABELS,
  IMS_DEVICE_CODE_ALIAS,
  IMS_BUSINESS_OPTIONS,
  IMS_BUSINESS_FEATURE_MAP,
  IMS_REQUEST_TYPE_FROM_UPGRADE,
  IMS_REQUEST_TYPE_BY_CRM,
  IMS_REQUEST_TYPE_DEFAULT,
};
